import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../../Helper/ToastMessage";

// Get Table Data
export const WTPQuantityOfWaterTableDataAPI = createAsyncThunk("WTPQuantityOfWaterTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        ReadingDate,
        M_WardID,
        M_UserID,
        token,
        From,
        To,
        handleGetExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_WEB_WTP_T_WTP_WaterQuantity_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&ReadingDate=${ReadingDate}&M_WardID=${M_WardID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {
                handleGetExport && handleGetExport()
                return result.data.table
            } else {
                return result
            }
        })
})

const WTPQuantityOfWaterTableDataSlice = createSlice({
    name: " WTPQuantityOfWaterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPQuantityOfWaterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPQuantityOfWaterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPQuantityOfWaterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPQuantityOfWaterTableDataReducer = WTPQuantityOfWaterTableDataSlice.reducer

// Export Data API

export const WTPQuantityOfWaterTableExportDataAPI = createAsyncThunk("WTPQuantityOfWaterTableExportData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        ReadingDate,
        M_WardID,
        M_UserID,
        token,
        From,
        To
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_WEB_WTP_T_WTP_WaterQuantity_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&ReadingDate=${ReadingDate}&M_WardID=${M_WardID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPQuantityOfWaterTableExportDataSlice = createSlice({
    name: " WTPQuantityOfWaterTableExportData",
    initialState: {
        isExportLoading: false,
        ExporttableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPQuantityOfWaterTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WTPQuantityOfWaterTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExporttableData = action.payload;
        });
        builder.addCase(WTPQuantityOfWaterTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExporttableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPQuantityOfWaterTableExportDataReducer = WTPQuantityOfWaterTableExportDataSlice.reducer


// InsertUpdate Table Data

export const WTPQuantityOfWaterPostDataAPI = createAsyncThunk("WTPQuantityOfWaterPostData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        RawWaterReceivedFromDam,
        RawWaterSuppliedToMJP,
        ReadingDate,
        NetRawWaterSuppliedToNMMC,
        TreatmentLossInMLD,
        QuantityofPureWater,
        M_UserID,
        token,
        setloading,
        handleIsPost,
        handleOnCloseClick
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_FinancialYearID", M_FinancialYearID);
    formdata.append("M_MonthID", M_MonthID);
    formdata.append("ReadingDate", ReadingDate);
    formdata.append("RawWaterReceivedFromDam", RawWaterReceivedFromDam);
    formdata.append("RawWaterSuppliedToMJP", RawWaterSuppliedToMJP);
    formdata.append("NetRawWaterSuppliedToNMMC", NetRawWaterSuppliedToNMMC);
    formdata.append("TreatmentLossInMLD", TreatmentLossInMLD);
    formdata.append("QuantityofPureWater", QuantityofPureWater);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    setloading(true)
    return fetch(`${BaseUrl}/Master/Post_WEB_WTP_T_WTP_WaterQuantity_Insert`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            setloading(false)
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                handleOnCloseClick(false)
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }

            return result
        })
})

const WTPQuantityOfWaterPostDataSlice = createSlice({
    name: "WTPQuantityOfWaterPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPQuantityOfWaterPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPQuantityOfWaterPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPQuantityOfWaterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPQuantityOfWaterPostDataReducer = WTPQuantityOfWaterPostDataSlice.reducer



// Delete API

export const WTPQuantityOfWaterDeleteAPI = createAsyncThunk("WTPQuantityOfWaterDelete", async ({ data }) => {

    const {
        T_WTP_WaterQuantityID,
        M_UserID,
        handleIsPost,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_WTP_WaterQuantityID", T_WTP_WaterQuantityID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/WEB_WTP_T_WTP_WaterQuantity_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
            } else {
                toastErrorr(result.message)
            }
            return result

        })
})

const WTPQuantityOfWaterDeleteSlice = createSlice({
    name: "WTPQuantityOfWaterDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPQuantityOfWaterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WTPQuantityOfWaterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            toastSuccesss(action.payload.message)
        });
        builder.addCase(WTPQuantityOfWaterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPQuantityOfWaterDeleteReducer = WTPQuantityOfWaterDeleteSlice.reducer
